// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';


export class DeleteMapAction implements flatbuffers.IUnpackableObject<DeleteMapActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):DeleteMapAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsDeleteMapAction(bb:flatbuffers.ByteBuffer, obj?:DeleteMapAction):DeleteMapAction {
  return (obj || new DeleteMapAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsDeleteMapAction(bb:flatbuffers.ByteBuffer, obj?:DeleteMapAction):DeleteMapAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new DeleteMapAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.MapDeleteMap;
}

static startDeleteMapAction(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.MapDeleteMap);
}

static endDeleteMapAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createDeleteMapAction(builder:flatbuffers.Builder, type:ActionType):flatbuffers.Offset {
  DeleteMapAction.startDeleteMapAction(builder);
  DeleteMapAction.addType(builder, type);
  return DeleteMapAction.endDeleteMapAction(builder);
}

unpack(): DeleteMapActionT {
  return new DeleteMapActionT(
    this.type()
  );
}


unpackTo(_o: DeleteMapActionT): void {
  _o.type = this.type();
}
}

export class DeleteMapActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.MapDeleteMap
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return DeleteMapAction.createDeleteMapAction(builder,
    this.type
  );
}
}
